import { Converter } from 'eilmer-mvvm/converters'

export default class UsersConverter extends Converter {

    constructor(permissions) {
      super()
      this.permissions = permissions
    }
  
    convertFrom(viewModelValue, bindingContext) {
      return viewModelValue?.filter(user => this.permissions?.hasPrecedence(user.getUserRole(), true) || false)
    }
  
  }